import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';
import * as Commonmark from 'react-commonmark';

const CovidStatement = (
  {channelKey, covidMessage}: { channelKey: string, covidMessage: string },
) => {

  // Once all products have covid message added the check can be removed.
  if (['fst-b2c', 'tpl-b2c', '247-b2c', 'ven-b2c'].includes(channelKey)) {
    if (!covidMessage || covidMessage === '') {
      return null;
    }

    const covidClass = ['tpl-b2c', '247-b2c'].includes(channelKey) ?
      'covid-statement covid-colour' : 'covid-statement';

    return (
          <div className={covidClass}>
            <ReactMarkdown
              source={covidMessage}
              renderers={{
                link: (props) => (
                  <a href={props.href} target="_blank">
                    {props.children}
                  </a>
                ),
              }}
            />
          </div>
    );
  }
  if (channelKey === 'lsb-b2c') {
    return (
      <Commonmark
        className="declaration-links"
        source={covidMessage}
      />
    );
  }

  if (channelKey === 'tpl-b2c') {
    return (
      <div>
        <h4 style={{ color: '#c22116' }}>Important Notice</h4>
        <p style={{ color: '#c22116' }}>
          <u>Coronavirus (Covid-19)/Pandemic Statement</u><br /><br />

          This policy will ONLY provide cover for claims as a result of pandemic and/ or epidemic, including but not
          limited to Coronavirus (Covid-19) within the following sections:<br /><br />
          <p style={{ color: '#c22116' }}>
            • Section 1 – Emergency Medical Expenses (due to COVID-19)<br />
            Our policy provides cover for Emergency Medical expenses if an <u>insured person</u> contracts Coronavirus
            whilst abroad.
          </p>
          <p style={{ color: '#c22116' }}>
            • Section 4 - Cancelling & cutting short your trip< br/>
            If it is necessary and unavoidable to cancel or cut short your trip because an <u>insured person</u> tests
            positive for Coronavirus within 14 days of your trip departure date, or is admitted to hospital due to
            testing positive for coronavirus  after the purchase of this policy.
          </p>
        </p>
        <p style={{ color: '#c22116' }}>
          <u>FCDO Statement</u><br /><br />
          Additionally, there is no cover under this policy if the Foreign Commonwealth & Development Office (FCDO)
          advises you not to travel, for example where the FCDO advise against all, or all but essential travel.
          It is your responsibility to check the FCDO website (at <a
          style={{ color: '#c22116', textDecoration: 'underline' }}
          href={'https://www.gov.uk/foreign-travel-advice'} target={'_blank'}>
          www.gov.uk/foreign-travel-advice
        </a>) prior to your
          departure, as travelling against the advice of the FCDO will invalidate your cover.
        </p>
      </div>
    );
  }

  return (
    <div>
      <h4 style={{ color: '#c22116' }}>Important Notice</h4>
      <p style={{ color: '#c22116' }}>
        Please note, our policies do not provide cover for cancellation, abandonment or curtailment claims if the
        Foreign and Commonwealth Office (FCO) advises against all or “all but essential” travel.
        Our policies will also not cover any claims caused by or relating to Coronavirus, COVID-19, Severe Acute
        Respiratory Syndrome (SARS-COV-2), any mutation of Coronavirus, COVID-19 or SARs-COV-2 or any pandemic or
        fear or threat of any the above. We also can not cover any claims relating to any fear or threat concerning
        these viruses. This general exclusion applies to all sections of cover except for the Emergency Medical
        Expenses section.
      </p>
      <p style={{ color: '#c22116' }}>
        Click <a
        style={{ color: '#c22116', textDecoration: 'underline' }}
        href={'https://www.gov.uk/foreign-travel-advice'} target={'_blank'}>
        here
      </a> for more information.
      </p>
    </div>
  );
};

export default CovidStatement;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/components/CovidStatement/index.tsx